var map = {
	"./generic-bg--1.jpg": 2076,
	"./generic-bg--2.jpg": 2077,
	"./generic-bg--3.jpg": 2078,
	"./generic-bg--4.jpg": 2079,
	"./generic-bg--5.jpg": 2080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2075;